const animationVarients = {
  down: {
    visible: {
      top: 0,
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    hidden: {
      top: '-100dvh',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    exit: {
      top: '100dvh',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    }
  },
  up: {
    visible: {
      top: 0,
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    hidden: {
      top: '100dvh',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    exit: {
      top: '-100dvh',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    }
  },
  left: {
    visible: {
      left: 0,
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    hidden: {
      left: '100dvw',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    exit: {
      left: '-100dvw',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    }
  },
  right: {
    visible: {
      left: 0,
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    hidden: {
      left: '-100dvw',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    },
    exit: {
      left: '100dvw',
      transition: { ease: [0.26, 0.86, 0.44, 0.985], duration: 0.75 }
    }
  },
  default: {
    visible: {
      opacity: 1,
      transition: { duration: 0.4 }
    },
    hidden: {
      opacity: 0,
      transition: { duration: 0.4 }
    },
    exit: {
      opacity: 0,
      transition: { duration: 0.4 }
    }
  }
}

export default animationVarients
